import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { site } from '../data/landing';
const paymentMethods = [{
  emoji: '📱',
  label: 'Pago Móvil',
  sub: 'Tasa BCV oficial',
  highlight: true
}, {
  emoji: '💳',
  label: 'Tarjeta',
  sub: 'Visa / Mastercard',
  highlight: false
}, {
  emoji: '₿',
  label: 'Binance Pay',
  sub: 'USDT / BTC',
  highlight: false
}];
export function FinalCtaSection() {
  return <section id="comprar" className="bg-gradient-to-br from-success to-success-dark py-16 text-white sm:py-24" data-id="element-74" data-mp="333p3qm012zkt">
      <Reveal className="mx-auto flex max-w-3xl flex-col items-center px-4 text-center sm:px-6" data-id="element-75" data-mp="382i4rey4oy43">
        <p className="rounded-full bg-ink/20 px-4 py-1.5 text-sm font-bold" data-id="element-76" data-mp="3cua0e3w55u13">⚡ Precio de lanzamiento — Solo esta semana</p>
        <h2 className="mt-6 text-[28px] font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-77" data-mp="2fdbbaudj6ypp">
          Empieza a cotizar como profesional hoy
        </h2>
        <p className="mt-6 flex items-baseline gap-3" data-id="element-78" data-mp="2dc0ako8az2yt">
          <span className="text-2xl font-bold text-white/70 line-through decoration-[3px] sm:text-3xl" data-id="element-79" data-mp="2dbgvrgdy8up0">$47</span>
          <span aria-hidden="true" className="text-2xl text-white/70" data-id="element-80" data-mp="28dp0cce3iqg2">→</span>
          <span className="text-5xl font-black tracking-tight sm:text-7xl" data-id="element-81" data-mp="23kvvzpmjhk4i">{site.price}</span>
          <span className="text-lg font-bold text-white/90" data-id="element-82" data-mp="1ymcafqbuyaco">USD</span>
        </p>
        <CtaButton variant="dark" className="mt-8" data-id="element-83" data-mp="1ulse2oz3zarl">
          Obtener Cotizador PRO ahora <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-84" data-mp="1pmp7h03hcwhi" />
        </CtaButton>

        {/* Métodos de pago */}
        <div className="mt-6 w-full rounded-xl bg-ink/20 px-4 py-4" data-id="element-85" data-mp="1kmjf1hpdz5yd">
          <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-white/60" data-id="element-86" data-mp="1fo9jh5zr23c8">Formas de pago disponibles</p>
          <div className="flex flex-wrap justify-center gap-2" data-id="element-87" data-mp="3f1lyoyrr7ttd">
            {paymentMethods.map(m => <div key={m.label} className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold ${m.highlight ? 'bg-white text-success ring-2 ring-white' : 'bg-white/10 text-white'}`} data-id="element-88" data-mp="3a3c2ckuamn66">
                <span aria-hidden="true" data-id="element-89" data-mp="ygic13acmbn8">{m.emoji}</span>
                <span data-id="element-90" data-mp="13dh5djm6uekd">
                  {m.label}
                  <span className={`ml-1 text-xs font-normal ${m.highlight ? 'text-success/70' : 'text-white/60'}`} data-id="element-91" data-mp="13ea1lqnitlo9">{m.sub}</span>
                </span>
              </div>)}
          </div>
        </div>

        <a href={site.whatsappUrl} target="_blank" rel="noopener noreferrer" className="mt-5 text-base font-semibold text-white underline decoration-white/40 underline-offset-4 transition-colors duration-150 ease-out hover:decoration-white" data-id="element-92" data-mp="1w0bmq7npkxtm">
          📱 ¿Preguntas? Escríbenos por WhatsApp
        </a>
        <p className="mt-6 text-sm leading-relaxed text-white/90" data-id="element-93" data-mp="aqe62p9otzt2">
          ✅ Pago seguro · ✅ Acceso inmediato · ✅ Funciona en Android e iPhone · ✅ Garantía 7 días
        </p>
      </Reveal>
    </section>;
}